<template>
  <ul class="new-lead-navigation" :class="{show: show}">
    <li>
      {{ $t('navigation.newLeadMenu.title') }}
    </li>
    <li>
      {{ $t('navigation.newLeadMenu.emptyForm') }}
    </li>
    <li v-for="(formCategory, formCategoryName) in formData" :key="formCategoryName">
      {{ formCategoryName }}
      <ul>
        <li v-for="(_, form) in formCategory" :key="form">
          {{ form }}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'NewLeadNavigation',
  props: {
    formData: Object,
    show: Boolean
  }
}
</script>

<style scoped lang="scss">
  .new-lead-navigation {
    position: absolute;
    top: 64px;
    left: 64px;
    background-color: $white;
    padding-top: 64px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, .29);
    //transform: translate(-100%,0);
    display: none;

    &.show {

    }
  }
</style>
